import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-entra-telefone-sichtbar-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerEntraTelefoneSichtbarAdminEffects {

    BenutzerEntraTelefoneSichtbarAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_ENTRA_TELEFONE_SICHTBAR_ADMIN),
        mergeMap((x: ac.PostBenutzerEntraTelefoneSichtbarAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerEntraTelefoneSichtbarAdmin(x.benutzerTelefoneSichtbarkeitRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerEntraTelefoneSichtbarAdminErfolgreichAction(result, x.benutzerTelefoneSichtbarkeitRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerEntraTelefoneSichtbarAdminFehlerAction(error, x.benutzerTelefoneSichtbarkeitRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
